import ApiService, {callCustomMethodAsync} from "../service/ApiService";

let moduleApi = {};
let moduleName = "insurance";

moduleApi.create = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter, loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: loading == undefined ? false : loading
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};


moduleApi.CheckImportInsurance = async (data) => {
  let api = {
    module: moduleName,
    type: "CheckImportInsurance",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api)
  mushroom[moduleName].invalidCache()
  return result
};

moduleApi.ImportInsurance = async (data) => {
  let api = {
    module: moduleName,
    type: "ImportInsurance",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api)
  mushroom[moduleName].invalidCache()
  return result
};

moduleApi.GetInsurances = async (data) => {
  let api = {
    module: moduleName,
    type: "GetInsurances",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await callCustomMethodAsync(api)
  mushroom[moduleName].invalidCache()
  return result
};

export default moduleApi;
